const SOLE_REPRESENTATION = 'sole-representation'
const RELIGION = 'religion'
const FOREIGN = 'foreign'
const QUANTITATIVE = 'quantitative'
const NO_REPRESENTATION= 'no-representation'

export default {
    SOLE_REPRESENTATION: SOLE_REPRESENTATION,
    RELIGION: RELIGION,
    FOREIGN: FOREIGN,
    QUANTITATIVE: QUANTITATIVE,
    NO_REPRESENTATION: NO_REPRESENTATION
}
